import { __assign, __decorate, __extends, __rest } from "tslib";
import React from "react";
import { Components, Misc, Utils } from "@singularsystems/neo-core";
import { observer } from 'mobx-react';
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerRef = React.createRef();
        return _this;
    }
    ProgressBar.prototype.componentDidMount = function () {
        if (this.innerRef.current) {
            Components.AnimationHelper.triggerReflow(this.innerRef.current);
        }
    };
    ProgressBar.prototype.render = function () {
        var _a = this.props, progress = _a.progress, progressState = _a.progressState, type = _a.type, variant = _a.variant, reverse = _a.reverse, domProps = __rest(_a, ["progress", "progressState", "type", "variant", "reverse"]);
        var innerClassName = "progress-bar";
        var isReversed = reverse === true;
        if (Misc.Settings.progressBar.reverse) {
            isReversed = !isReversed;
        }
        if (isReversed) {
            innerClassName += " reversed";
        }
        if (type === "striped" || type === "animated") {
            innerClassName += " progress-bar-striped";
            if (type === "animated") {
                innerClassName += " progress-bar-animated";
            }
        }
        if (variant) {
            innerClassName += " bg-" + variant;
        }
        domProps.className = Utils.joinWithSpaces(domProps && domProps.className, "progress");
        var style = {};
        if (progressState) {
            progress = progressState.progress;
            style.transitionDuration = "0.25s";
            style.transitionTimingFunction = "linear";
        }
        style.width = progress ? (progress * 100) + "%" : "0";
        return (React.createElement("div", __assign({}, domProps),
            React.createElement("div", { ref: this.innerRef, className: innerClassName, style: style })));
    };
    ProgressBar = __decorate([
        observer
    ], ProgressBar);
    return ProgressBar;
}(React.Component));
export default ProgressBar;
